import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { Logout } from '../Pages/Logout';
import { formatDateForTokens } from '../utils/RegisterApplicationBodyFormatter';


export const AdminAuthGuard = ({ children }) => {
    const { isAuthenticated, user, onLogout } = useContext(AuthContext);

    if (new Date(user.validTo) < new Date()) {
        sessionStorage.removeItem('auth');
        onLogout();
        return <Navigate to="/schadm/login" replace />
    }

    if (!user.token) {
        return <Navigate to="/schadm/login" replace />
    }

    if (!isAuthenticated) {
        return <Navigate to="/schadm/login" replace />
    }

    if (user.role == 'Admin' || user.role == 'SuperAdmin' || user.role == 'Director' || user.role == 'Municipality') {
        return children ? children : <Outlet />
    }

    return <Navigate to="/" replace />
};